import { Box, BoxProps } from "@mui/material";
import { ReactElement } from "react";

export type CharacterCountProps = {
  count: number;
  max?: number;
  containerProps?: BoxProps;
};

export const CharacterCount = ({
  count,
  max,
  containerProps,
}: CharacterCountProps): ReactElement => {
  const value = Math.max(0, count || 0);
  const maximum = (max && Math.max(0, max)) || undefined;
  const baseColor = containerProps?.color || "inherit";
  const hasExceededMax = maximum && value > maximum;

  return (
    <Box
      component="span"
      {...containerProps}
      sx={{ textWrap: "nowrap", ...containerProps?.sx }}
      color={hasExceededMax ? "error" : baseColor}
    >
      {[value, maximum].filter((x) => x != null).join(" / ")}
    </Box>
  );
};
